import { useFormContext } from 'react-hook-form';
import { ValidateUtils } from '@shared/utils';
import type { IForm } from './requisites';
import { Button, ColorsEnum, ErrorMessage, Icon, Text } from '@shared/widgets';
import CopyIcon from '@assets/icons/copy.svg';
import EditIcon from '@assets/icons/edit.svg';

interface ItemProps {
  name: string;
  value: string;
  isEditableLabel: boolean;
  isEditableCost: boolean;
  isCopy: boolean;
}

export const Item = (props: ItemProps) => {
  const {
    register,
    formState: { errors },
    setFocus,
  } = useFormContext<IForm>();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(props.value);
  };

  const editHandler = () => {
    switch (props.name) {
      case 'Account label':
        setFocus('accountLabel');
        break;
      case 'Cost centre':
        setFocus('costCentre');
        break;
      default:
        break;
    }
  };

  const isEditing = props.isEditableLabel || props.isEditableCost;
  return (
    <div className='flex items-center justify-between'>
      <div>
        <Text size='sm' color={ColorsEnum.Secondary}>
          {props.name}
        </Text>
        <Text className='max-w-52 pr-3 break-words' weight='semibold' color={ColorsEnum.Primary} size='sm'>
          {isEditing ? (
            <>
              {props.isEditableLabel && (
                <>
                  <input
                    {...register('accountLabel', { required: ValidateUtils.requiredErrorMessage })}
                    className='border-none rounded-sm appearance-none bg-transparent outline-none p-0 w-full'
                    placeholder={`Enter ${props.name.toLowerCase()}...`}
                  />
                  <ErrorMessage text={errors.accountLabel?.message} />
                </>
              )}
              {props.isEditableCost && (
                <>
                  <input
                    {...register('costCentre', { required: ValidateUtils.requiredErrorMessage })}
                    className='border-none rounded-sm appearance-none bg-transparent outline-none p-0 w-full'
                    placeholder={`Enter ${props.name.toLowerCase()}...`}
                  />
                  <ErrorMessage text={errors.costCentre?.message} />
                </>
              )}
            </>
          ) : (
            props.value
          )}
        </Text>
      </div>
      <div className='flex gap-2 items-center'>
        {props.isEditableLabel && (
          <Button color='icon' onClick={editHandler}>
            <Icon icon={<EditIcon width='22' height='22' />} color='primary' />
          </Button>
        )}
        {props.isEditableCost && (
          <Button color='icon' onClick={editHandler}>
            <Icon icon={<EditIcon width='22' height='22' />} color='primary' />
          </Button>
        )}
        {props.isCopy && (
          <Button color='icon' onClick={handleCopy}>
            <Icon icon={<CopyIcon />} color='primary' />
          </Button>
        )}
      </div>
    </div>
  );
};
